import React, { useState } from 'react'
import { faCheckCircle, faPowerOff } from "@fortawesome/free-solid-svg-icons"

import Input from 'components/Input'
import ButtonPrimary from 'components/ButtonPrimary'

import styles from './styles.module.scss'

const ConfirmModal = props => {
  const [info, setInfo] = useState({})

  return (
    <div className={`${styles.mask} ${styles.mask__confirm}`}>
      <div className={styles.mask__container}>
        {props.title && <h3>{props.title}</h3>}
        {props.text && <p>{props.text}</p>}
        {props.options && (
          <div className={styles.mask__options}>
            <Input type="select" id="option" label={props.optionsLabel} defaultValue={info.type} dropdownOptions={props.options} onChange={(id, val) => setInfo(i => { return { ...i, [id]: val } })} />
          </div>
        )} 
        <div className={styles.mask__actions}>
          <ButtonPrimary color="grey" icon={faPowerOff} onClick={props.onCancel}>{props.cancelText || 'Cancel'}</ButtonPrimary>
          <ButtonPrimary color="navy" icon={faCheckCircle} onClick={() => {
            props.onConfirm(info)
          }}>{props.confirmText || 'Confirm'}</ButtonPrimary>
        </div>
      </div>
    </div>
  )
}

export default ConfirmModal